import { Divider } from '@/components/Divider';
import { theme } from '@theguarantors/tg-package-material-ui';

export const InviteLeaseDetailsFormDivider = () => (
  <Divider
    sx={{
      borderColor: `${theme.palette.neutralGrey[200]} !important`,
      my: 3,
      [theme.breakpoints.down('md')]: {
        borderColor: `transparent !important`,
        color: 'transparent !important',
        my: 1.5,
      },
    }}
  />
);
